import $ from 'jquery';

const LIST_HASH_ATTR = 'data-list-hash';
const LIST_HASH_SELECTOR = '[' + LIST_HASH_ATTR + ']';
const LIST_FILTER_SELECTOR = '.list-filter';
const LOADING_ELEMENT_CLASS = 'loading-element';
const IS_LOADING_ELEMENT_CLASS = 'loading-element--is-loading';
const PAGINATOR_SELECTOR = '.pagination';
const PAGINATOR_LINK_SELECTOR = '.page-numbers'
const PAGINATOR_DISABLED_SELECTOR = '.disabled'

export default class ListHandler {
    constructor() {
        this.setupEvents();
    }

    setupEvents() {
        $(document).on('click', PAGINATOR_LINK_SELECTOR, async (ev) => {
            await this.onPageChange(ev);
        });

        $(document).on('change', LIST_FILTER_SELECTOR, async (ev) => {
            await this.onChange(ev);
        });

        $(document).on('submit', LIST_FILTER_SELECTOR, async (ev) => {
            await this.onSubmit(ev)
        })
    }

    onPageChange(ev) {
        const $link = $(ev.target);
        const url = $link.attr('href');
        const $parent = $link.closest(LIST_HASH_SELECTOR);

        if($link.is(PAGINATOR_DISABLED_SELECTOR)) {
            return;
        }
        
        if (!url) {
            return;
        }

        if (!$parent.length) {
            return;
        }

        const succesfullyUpdated = this.refreshList($parent, url)

        if(!succesfullyUpdated) {
            return;
        }

        ev.preventDefault();
    }

    setElementLoading(element, isLoading) {
        let newClasses = [LOADING_ELEMENT_CLASS];
        let removeClasses = [IS_LOADING_ELEMENT_CLASS];

        if (isLoading) {
            newClasses.push(IS_LOADING_ELEMENT_CLASS);
            removeClasses = [];
        }

        element.addClass(newClasses).removeClass(removeClasses);
    }

    async onChange(ev) {
        const $target = $(ev.currentTarget);
        const $parent = $target.closest(LIST_HASH_SELECTOR);

        this.setElementLoading($parent, false);

        $target.submit();
    }

    async onSubmit(ev) {
        const $target = $(ev.currentTarget);
        const $parent = $target.closest(LIST_HASH_SELECTOR);
        const actionUrl = $target.attr('action');
        const queryString = $target.serialize();
        const url = actionUrl + '?' + queryString;

        if (!$parent.length) {
            return;
        }

        const succesfullyUpdated = this.refreshList($parent, url)
        
        if(!succesfullyUpdated) {
            return;
        }

        ev.preventDefault();
    }

    async refreshList($listElement, pageUrl) {
        const listHash = $listElement.attr(LIST_HASH_ATTR);

        if (!listHash) {
            return false;
        }
    
        this.setElementLoading($listElement, true);

        const response = await fetch(pageUrl);
        const htmlResponse = await response.text();

        const $newForm = $(htmlResponse).find('[' + LIST_HASH_ATTR + '=' + listHash + ']');
        this.setElementLoading($newForm, true);

        $listElement.replaceWith($newForm);

        window.history.pushState({}, undefined, pageUrl)

        setTimeout(() => {
            this.setElementLoading($newForm, false);
            $([document.documentElement, document.body]).animate({
                scrollTop: $newForm.offset().top
            }, 250);
        }, 0);

        return true;
    }
}


// WEBPACK FOOTER //
// ./assets/scripts/front/App/ListHandler.js